<template>
  <div class="kabs-card-container md-layout-item md-xlarge-size-30 md-large-size-30 md-medium-size-30 md-small-size-30 md-xsmall-size-100">
    <div class="card-image">
      <slot name="card-image" />
    </div>
    <div class="card-contents">
      <slot name="card-details" />
    </div>
  </div>
</template>
<script>
export default {
  name: "StudioList"
}
</script>
<style lang="scss">
.kabs-card-container {
  min-height: 406px;
  overflow: hidden;
  background-color: $color-white;
  object-fit: contain;
  border-radius: 7px;
  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  &:not(:last-child) {
    margin-right: 15px;
  }
  .card-image {
    min-height: 198px;
    max-height: 198px;
    .image-avatar {
      position: relative;
      top: 30px;
      display: block;
      margin: auto
    }
    .boder-image-circle {
      height: inherit;
      min-height: inherit;
      max-height: inherit;
      img {
        width: 192px;
        height:192px;
        display: block;
        margin: auto;
        border-radius: 50%;
        border: 2px solid $color-primary;
        margin-top: 18px;
      }
    }
  }
  .card-contents {
    margin: 24px;
    text-align: left;
    h1 {
      font-size: 21px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.48;
      letter-spacing: normal;
      color: $color-black;
    }
    .body-details {
      overflow: hidden;
      max-height: 220px;
      text-overflow: ellipsis;
      word-break: break-word;
      color: #a1aeb7;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.71;
      letter-spacing: normal;
      a {
        color: #b42476;
      }
      h2 {
        font-weight: normal !important;
        font-size: 14px;
      }
    }
  }
}
</style>